module.exports = __webpack_public_path__ + "img/0Q3A8493_L_Black.c7f2ab0c.jpg";